import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

// import Swiper core and required modules
import SwiperCore, { Navigation, SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
SwiperCore.use([Navigation]);

import { MediaItemModel } from '../../../models/media-item.model';
import { ImageSliderService } from '../../../services/image-slider.service';

@Component({
  selector: 'image-slider-modal',
  templateUrl: './image-slider-dialog.component.html',
})
export class ImageSliderDialogComponent implements OnInit, OnDestroy {

  @ViewChild('swiper') swiper?: SwiperComponent;

  public images: MediaItemModel[] = [];

  public currentSlideIndex: number;
  public ready: boolean;
  public largeSwiperConfig: SwiperOptions;
  public swiperDisabled: boolean = false;

  private data: any;
  private imageSliderService: ImageSliderService;

  /**
   * On initialization
   *
   * @return void
   */
  public ngOnInit(): void {
    if (this.data) {

      this.images = this.data.images;
      this.currentSlideIndex = this.data.currentSlideIndex;
      this.imageSliderService = this.data.imageSliderService;

      this.largeSwiperConfig = {
        navigation: {
          nextEl: '#dialog-gallery-swiper .swiper-button-next',
          prevEl: '#dialog-gallery-swiper .swiper-button-prev',
        },
        loop: true,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        initialSlide: this.data.currentSlideIndex,
        grabCursor: false,
      };

      this.ready = true;
    }
  }

  /**
   * When the component is destroyed
   *
   * @return void
   */
  public ngOnDestroy(): void {
    this.imageSliderService.setSlideIndex.next(this.swiper?.swiperRef?.realIndex || 0);
  }

  /**
   * Disables navigation on the swiper element when an image is zoomed in
   *
   * @param {{zoomed: boolean}} event
   *
   * @return void
   */
  public onImageZoomed(event: {zoomed: boolean}): void {
    this.largeSwiperConfig['allowTouchMove'] = !event.zoomed;
    this.swiperDisabled = event.zoomed;
  }

}
